import { InjectionToken } from '@angular/core';

export const SBB_DATEPICKER_2DIGIT_YEAR_PIVOT = new InjectionToken<number>(
  'SBB_DATEPICKER_2DIGIT_YEAR_PIVOT'
);
